import { render } from "./CpsGuideModal.vue?vue&type=template&id=56881a6a&scoped=true&ts=true"
import script from "./CpsGuideModal.vue?vue&type=script&lang=ts"
export * from "./CpsGuideModal.vue?vue&type=script&lang=ts"

import "./CpsGuideModal.vue?vue&type=style&index=0&id=56881a6a&lang=css&scoped=true"

import exportComponent from "/app/higgs.cps.portal.website/node_modules/.pnpm/vue-loader@16.8.3_f65c6e1beb608835961423903ad857fc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56881a6a"]])

export default __exports__